// src/components/ProcessManager/CommercialRegister/ProcessManagerCommercialRegisterTable.tsx
import React from 'react';
import { IProcessManager } from '../../Interfaces/IProcessManager';
import { ILegalTransactionRelationship } from '../../Interfaces/ILegalTransactionRelationship/ILegalTransactionRelationship';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import { ProcessManagerCommercialRegisterTableRow } from './ProcessManagerCommercialRegisterTableRow';
import { ILegalClient } from '../../Interfaces/ILegalClient';
import { ILegalPhaseFullObject } from '../../Interfaces/ILegalPhase';
import { ILegalRequirementState } from '../../Interfaces/ILegalRequirementState';

type RegisterPM = IProcessManager & { idProcessManagerType: 20 | 21 };

interface IProps {
  processManagerArray: IProcessManager[];
  setProcessManagerArray: Function;
  relationsships: ILegalTransactionRelationship[];
  setRelationships: Function;
  //
  legalClients: ILegalClient[];
  legalPhases: ILegalPhaseFullObject[];
  legalReqStates: ILegalRequirementState[];
  //
  enableShowType?: boolean;
  includeTypes?: (20 | 21)[];
}

const makeIsRegister =
  (includeTypes: (20 | 21)[]) =>
  (pm: IProcessManager): pm is RegisterPM =>
    includeTypes.includes(pm.idProcessManagerType as 20 | 21);

export const ProcessManagerCommercialRegisterTable: React.FC<IProps> = ({
  processManagerArray,
  setProcessManagerArray,
  relationsships,
  setRelationships,
  legalClients,
  legalPhases,
  legalReqStates,
  enableShowType,
  includeTypes = [20, 21],
}) => {
  const isRegister = makeIsRegister(includeTypes);
  const showVorgangColumn = includeTypes.includes(20);

  return (
    <Table size='small'>
      <TableHead>
        <TableRow>
          <TableCell>Status</TableCell>
          <TableCell title='Automatisierungen' width={20}>
            Auto.
          </TableCell>
          {enableShowType && <TableCell>Art</TableCell>}
          <TableCell>
            Erfolgte
            <br />
            Prüfungen
          </TableCell>
          <TableCell>Datum</TableCell>
          {showVorgangColumn && <TableCell>Vorgang</TableCell>}
          <TableCell>Registergericht</TableCell>
          <TableCell>Registernummer</TableCell>
          <TableCell>Firmenname</TableCell>
          <TableCell>Aktionen</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {processManagerArray.filter(isRegister).map(pm => (
          <ProcessManagerCommercialRegisterTableRow
            key={`processmanager-${pm.idProcessManager}`}
            processManager={pm}
            processManagerArray={processManagerArray}
            setProcessManagerArray={setProcessManagerArray}
            relationsships={relationsships}
            setRelationships={setRelationships}
            legalClients={legalClients}
            legalPhases={legalPhases}
            legalReqStates={legalReqStates}
          />
        ))}
      </TableBody>
    </Table>
  );
};
